import type { SwiperOptions } from 'swiper';

export const paramsSwiperReviewCard: SwiperOptions = {
  freeMode: {
    enabled: true,
    sticky: false,
    momentumBounce: false,
  },
  navigation: true,
  slidesPerView: 'auto' as const,
};
